import {
   AudioIcon,
   CameraIconNew,
   ContactIcon,
   CsvIcon,
   DocIcon,
   DocumentIcon,
   DocxIcon,
   ExcelIcon,
   ImgIcon,
   LocationIcon,
   PdfIcon,
   PptIcon,
   PptxIcon,
   RarIcon,
   TextIcon,
   XlxsIcon,
   ZipIcon,
} from '@/assets/images';

import { hidePopup, showPopup } from '@/components/PopupContainer/popupService';
import AttachmentWebCamera from '@/features/chats/sub-features/media/ui/components/AttachmentWebCamera';
import { getAcceptString } from '../sub-features/media/utils/fileTypeUtils';

export const openCameraModal = activeChatId => {
   showPopup({
      visible: true,
      id: 'attachment_web_camera_popup',
      title: 'Take Photo',
      onRequestClose: () => hidePopup('attachment_web_camera_popup'),
      body: <AttachmentWebCamera activeChatId={activeChatId} />,
      className: 'attachment-web-camera-popup-modal',
   });
};

export const attachmentItems = [
   {
      icon: <CameraIconNew />,
      label: 'Camera',
      color: '#F13794',
      onFileChange: activeChatId => openCameraModal(activeChatId),
   },
   {
      icon: <LocationIcon />,
      label: 'Location',
      color: '#1CA953', // Placeholder for upcoming location functionality
   },
   {
      icon: <ImgIcon />,
      label: 'Photos & Videos',
      color: '#733DF9',
      accept: getAcceptString('imagevideo'),
      mediaType: 'imagevideo',
   },
   {
      icon: <AudioIcon />,
      label: 'Audio',
      color: '#F68F23',
      accept: getAcceptString('audio'),
      mediaType: 'audio',
   },
   {
      icon: <ContactIcon />,
      label: 'Contact',
      color: '#EF333E', // Placeholder for upcoming contact share functionality
   },
   {
      icon: <DocumentIcon />,
      label: 'Document',
      color: '#D12BD9',
      accept: getAcceptString('document'),
      mediaType: 'file',
   },
];

const FILE_TYPE_ICONS = {
   pdf: PdfIcon,
   doc: DocIcon,
   docx: DocxIcon,
   xls: ExcelIcon,
   xlsx: XlxsIcon,
   csv: CsvIcon,
   ppt: PptIcon,
   pptx: PptxIcon,
   txt: TextIcon,
   json: TextIcon,
   xml: TextIcon,
   zip: ZipIcon,
   '7z': ZipIcon,
   rar: RarIcon,
};

/**
 * Returns the appropriate icon component for a given file extension.
 * @param {string} ext - The file extension (e.g., 'pdf', '.docx').
 * @returns {React.ComponentType} The icon component.
 */
export const getFileIcon = ext => {
   if (!ext) return DocumentIcon;
   const cleanExt = ext.toString().toLowerCase();
   const key = cleanExt.startsWith('.') ? cleanExt.slice(1) : cleanExt;
   return FILE_TYPE_ICONS[key] ?? DocumentIcon;
};
